import { useSelector } from 'react-redux';
import { Typography } from '@interstate/components/Typography';
import * as offerSelectors from '@makemydeal/dr-dash-store/selectors/offerSelectors';
import { toRem } from '../../utils/pixelUtils';

const MaxResidualizedMsrpAppliedField = () => {
    const applied = useSelector(offerSelectors.getMaxResidualizedMsrpAppliedOverrideWithFallback);
    if (!applied) return null;

    return (
        <Typography
            variant="label-sm"
            data-testid="mrm-applied-label"
            color="sem.color.on-surface.success.default"
            sx={{ display: 'block', marginTop: toRem(6) }}
        >
            Applied
        </Typography>
    );
};

export default MaxResidualizedMsrpAppliedField;
